export enum BookingValidationStatus {
    VALIDATED = "VALIDATED",
    NON_VALIDATED = "NON_VALIDATED",
    DRAFT = "DRAFT",
}

export interface BookingValidationInterface {
    id: string;
    booking_id: string;
    user_id: string;
    status: BookingValidationStatus;
    duration: string;
    motive: string;
    created_at: object;
}
